import { render } from "./TrialPackageIndicator.vue?vue&type=template&id=65c72c99&scoped=true&ts=true"
import script from "./TrialPackageIndicator.vue?vue&type=script&lang=ts"
export * from "./TrialPackageIndicator.vue?vue&type=script&lang=ts"

import "./TrialPackageIndicator.vue?vue&type=style&index=0&id=65c72c99&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c72c99"]])

export default __exports__